import styled from "styled-components";
import { processCoupleSexWithAge } from "utils/processCouple";
import generatePath from "utils/generatePath";
import { useTranslation } from "react-i18next";
import Block from "components/layout/Block";
import routes from "containers";
import ConvertLocation from "components/other/ConvertLocation";
import TileOptimized from "components/layout/TileOptimized";
import UserAvatar from "./UserAvatar";
import Login from "./Login";
import Text from "components/typography/Text";
// import FollowersButton from "containers/Users/components/FollowersButton";

// ############################################################################

const Additional = styled("div")`
	margin-bottom: ${({ $noPaddingAndMarginTile }) =>
		$noPaddingAndMarginTile ? 0 : "0.5rem"};
	margin-top: 0.25rem;
`;

// ############################################################################

const UserTileForUsersViewGrid = ({
	additional,
	loginProps,
	avatarProps: avatarPropsDefault,
	additionalProps: additionalPropsDefault,
	user: {
		user_data,
		// followers,
		partner_1,
		partner_2,
		sex,
		city,
		country,
		avatar,
		login,
		status_vip,
		online,
		private_data,
		profile_status,
		id,
	},
	avatarOnly,
	link = true,
	noPaddingAndMarginTile = false,
}) => {
	const { t } = useTranslation(["common", "countries"]);
	const to = generatePath(routes.user.path, {
		login: login.toLowerCase(),
	});

	const additionalProps = {
		small: false,
		...additionalPropsDefault,
	};

	const avatarProps = {
		userId: id,
		size: "mlarge",
		login,
		src: avatar,
		online,
		privateData: private_data,
		status: profile_status,
		...avatarPropsDefault,
	};

	const additinalLineText = () => {
		if (sex === "couple") {
			return (
				<Block full line={additionalProps?.line}>
					<Text
						small={additionalProps?.small}
						line={additionalProps?.line}
					>
						{processCoupleSexWithAge({
							sex1: partner_1.sex,
							age1: partner_1.age,
							sex2: partner_2.sex,
							age2: partner_2.age,
							t,
						})}
					</Text>
				</Block>
			);
		}
		return (
			<Block full line={additionalProps?.line}>
				<Text
					small={additionalProps?.small}
					line={additionalProps?.line}
				>
					{t(`sexOptions.${sex}`)},
					{user_data.age && ` ${user_data.age} ${t("years")},`}
				</Text>
			</Block>
		);
	};

	const additinalLineTextBottom = () => {
		return (
			<Block full line={additionalProps?.line}>
				<Text
					small={additionalProps?.small}
					line={additionalProps?.line}
				>
					<ConvertLocation city={city} country={country} />
				</Text>
			</Block>
		);
	};

	const altText = () => {
		if (sex === "couple") {
			return `${processCoupleSexWithAge({
				sex1: partner_1.sex,
				age1: partner_1.age,
				sex2: partner_2.sex,
				age2: partner_2.age,
				t,
			})}, ${city && `${city}`}`;
		}
		return `${t(`sexOptions.${sex}`)},${
			user_data?.age ? ` ${user_data.age} ${t("years")},` : ""
		} ${city && `${city}`}`;
	};

	const avatarAlt = `${login} - ${altText()}`.trim();

	// ############################################################################

	return (
		<TileOptimized
			id={id}
			withShadowAndBorder
			to={link ? to : false}
			avatarComponent={<UserAvatar {...avatarProps} alt={avatarAlt} />}
			noPaddingAndMarginTile={noPaddingAndMarginTile}
			loginComponent={
				<Login
					oneLine
					login={login}
					vip={status_vip}
					padded
					{...loginProps}
					size="mbase"
					vipProps={{ height: 14, marginBottom: 0.125 }}
				/>
			}
			additionalLine={
				<Additional $noPaddingAndMarginTile={noPaddingAndMarginTile}>
					{!avatarOnly && (
						<Block color="black" style={{ fontSize: "0.85rem" }}>
							{additinalLineText()}
							{additinalLineTextBottom()}
						</Block>
					)}
					{additional &&
						typeof additional === "function" &&
						additional()}
				</Additional>
			}
		/>
	);
};

export default UserTileForUsersViewGrid;
